import React, { useState } from 'react';
import { Card, Pill } from '../ui';
import { PROGRAM_NAMES } from '../../../pages/journey/journeyApi';

export const AdminCatalog = ({ catalog }) => {
  const [role, setRole] = useState('java_dev');
  const [track, setTrack] = useState('fresher');
  const r = catalog.roles.find((x) => x.id === role);
  const missions = catalog.missions.filter((m) => m.program === 'skills' && m.role === role && (m.track || 'fresher') === track);
  const shared = catalog.missions.filter((m) => m.program !== 'skills');
  const sub = (t) => t.replaceAll('{role}', r.title).replaceAll('{candidates}', 'their target roles');
  return (
    <div className="grid xl:grid-cols-[300px_1fr] gap-6" data-testid="admin-catalog">
      <div className="space-y-1">
        <p className="text-xs text-slate-500 mb-2" data-testid="catalog-family-count">{new Set(catalog.roles.map((x) => x.family || x.id)).size} role families · Java and Python are specializations of Software Developer Trainee</p>
        {catalog.roles.map((x) => (
          <button key={x.id} onClick={() => setRole(x.id)} data-testid={`catalog-role-${x.id}`}
            className={`w-full text-left text-sm px-3 py-2 rounded-xl ${role === x.id ? 'bg-[#0b1f4d] text-white' : 'hover:bg-white'}`}>
            {x.title}</button>))}
      </div>
      <div className="space-y-4">
        <Card>
          <p className="font-outfit font-semibold text-lg text-[#0b1f4d]">{r.title} · competency framework</p>
          <div className="grid md:grid-cols-2 gap-2 mt-3">{r.competencies.map((c) => <div key={c.id} className="text-sm border border-slate-100 rounded-lg p-3"><strong>{c.name}</strong>{c.core && <Pill className="ml-2 bg-[#0b1f4d]/5">core</Pill>}<p className="text-xs text-slate-500">{c.description}</p></div>)}</div>
        </Card>
        <div className="inline-flex bg-white border border-slate-200 rounded-full p-1" data-testid="catalog-track-toggle">
          {[['fresher', 'Fresher track'], ['professional', 'Professional track']].map(([k, l]) => (
            <button key={k} onClick={() => setTrack(k)} data-testid={`catalog-track-${k}`}
              className={`px-4 py-1.5 rounded-full text-sm font-semibold ${track === k ? 'bg-[#0b1f4d] text-white' : 'text-slate-600'}`}>{l}</button>))}
        </div>
        {[...missions, ...shared].map((m, i) => (
          <React.Fragment key={m.id}>
          {i === missions.length && <p className="text-xs uppercase tracking-widest text-slate-500 pt-4" data-testid="catalog-shared-heading">Shared Career Direction & Readiness missions (same for every role and track)</p>}
          <Card data-testid={`catalog-mission-${m.id}`}>
            <div className="flex flex-wrap gap-2 mb-1"><Pill className="bg-teal-50 text-teal-700">{PROGRAM_NAMES[m.program]}</Pill><Pill className="bg-slate-100 capitalize">{m.kind} · {m.level}</Pill>{m.requires_specialist && <Pill className="bg-teal-50 text-teal-700">specialist review</Pill>}</div>
            <p className="font-medium text-[#0b1f4d]">{sub(m.title)}</p><p className="text-sm text-slate-600 mt-1">{sub(m.brief)}</p>
            {m.employer_check && <p className="text-xs text-slate-600 mt-2"><strong>Employers check:</strong> {sub(m.employer_check.join(' · '))}</p>}
            {m.time_estimate && <p className="text-xs text-slate-500 mt-1">Time: {m.time_estimate}</p>}
            <p className="text-xs text-slate-500 mt-2">Rubric: {m.rubric.map((x) => `${sub(x.name)} ×${x.weight}`).join(' · ')}</p>
          </Card>
          </React.Fragment>))}
        {r.depth !== 'deep' && <Card className="text-sm text-amber-700">Framework role: a generated practical diagnostic is available now; full mission templates are planned after Release 1.</Card>}
      </div>
    </div>
  );
};
